import React from 'react';
import moment from 'moment-timezone';
import { Typography, List, Card } from 'antd';
import './pageTechnicalInfo.css';
import AutoSizeTitle from '../components/autoSizeTitle/AutoSizeTitle';

const { Title, Text } = Typography;

const PageTechnicalInfo = ({ selectedEvaluation, totalResults, individualResults, pageNumber }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const isCulture = [selectedEvaluation?.evl_srv_id, selectedEvaluation?.evl_srv_id_id, selectedEvaluation?.srv_id]
        .includes(3);

    // Categorías (cultura) derivadas de la agregación por dimensiones -> categories
    const cultureCategories = totalResults?.average_by_categories || [];

    // Cobertura: relaciones finalizadas / total
    const relationshipsFinished = totalResults?.relationships_finished || 0;
    const relationshipsTotal = totalResults?.relationships_total || 0;
    const coveragePct = relationshipsTotal > 0
        ? Math.round((relationshipsFinished / relationshipsTotal) * 100)
        : 0;

    // Número de factores / preguntas (backend proporcionó questions_count)
    const questionsCount = totalResults?.questions_count || 0;

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />
                <div className="internal-page-info">
                    <Card
                        style={{
                            borderRadius: '8px',
                            border: '1px solid #d9d9d9',
                            backgroundColor: '#fafafaff',
                            boxShadow: 'none',
                        }}
                        styles={{ body: { padding: '16px 24px' } }}
                    >
                        <Title level={4} style={{ color: '#339C98', marginBottom: 16 }}>
                            Ficha Técnica
                        </Title>

                        {!isCulture && (
                            <>
                                <Text strong>Enfoque: </Text>
                                <Text>Cuantitativo</Text>
                                <br />
                                <Text strong>Dimensiones evaluadas:</Text>
                                <List
                                    className="list-with-bullets"
                                    size="small"
                                    dataSource={Object.entries(totalResults.average_by_dimension)}
                                    renderItem={([key, item]) => (
                                        <List.Item key={key}>{item.title}</List.Item>
                                    )}
                                />
                                <br />
                                <Text strong>Número de evaluados: </Text>
                                <Text>{individualResults.length}</Text>
                                <br />
                                <Text strong>Fecha de inicio: </Text>
                                <Text>{moment(selectedEvaluation.evl_start_date)
                                    .tz('America/Bogota')
                                    .format('DD [de] MMMM [de] YYYY')}</Text>
                                <br />
                                <Text strong>Fecha de finalización: </Text>
                                <Text>{moment(selectedEvaluation.evl_finish_date)
                                    .tz('America/Bogota')
                                    .format('DD [de] MMMM [de] YYYY')}</Text>
                                <br />
                                <Text strong>Duración por aplicación: </Text>
                                <Text>20 minutos</Text>
                            </>
                        )}

                        {isCulture && (
                            <>
                                <Text strong>Enfoque cuantitativo: </Text>
                                <Text>
                                    Encuesta del nivel de percepción de ajuste frente a la cultura requerida
                                    para el logro de la estrategia corporativa.
                                </Text>
                                <br />
                                <Text strong>Dimensiones evaluadas:</Text>
                                <List
                                    className="list-with-bullets"
                                    size="small"
                                    dataSource={cultureCategories}
                                    renderItem={(item) => <List.Item key={item}>{item.name}</List.Item>}
                                />
                                <br />
                                <Text strong>Número de factores para evaluación: </Text>
                                <Text>{questionsCount} preguntas</Text>
                                <br />
                                <Text strong>Duración por aplicación: </Text>
                                <Text>30 minutos</Text>
                                <br />
                                <Text strong>Cobertura: </Text>
                                <Text>{coveragePct}%</Text>
                                <br />
                                <Text strong>Fecha de inicio: </Text>
                                <Text>{moment(selectedEvaluation.evl_start_date)
                                    .tz('America/Bogota')
                                    .format('DD [de] MMMM [de] YYYY')}</Text>
                                <br />
                                <Text strong>Fecha de finalización: </Text>
                                <Text>{moment(selectedEvaluation.evl_finish_date)
                                    .tz('America/Bogota')
                                    .format('DD [de] MMMM [de] YYYY')}</Text>
                                <br />
                                <Text strong>Número de evaluados: </Text>
                                <Text>{relationshipsFinished}</Text>
                            </>
                        )}
                    </Card>
                </div>
                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageTechnicalInfo;
